import React, { ReactNode } from "react";
import "i18next";
import { Resource } from "i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import i18n from "i18next";
import { I18nextProvider, initReactI18next } from "react-i18next";

import { currentLanguage } from "../utils/routes";
import { getResourcesWithFallbacks } from "./browser-resources";
import { config } from "./config";
import { formatLocale } from "./utils";
import { getNamespaceForBuildType } from "./resources";

export const configureBrowserI18n = async (resources: Resource, lng: string, namespace: string) => {
  if (!i18n.isInitialized) {
    await i18n
      .use(initReactI18next)
      .use(HttpBackend) // Load translations using http-backend
      .use(LanguageDetector) // Detect user language
      .init(
        config(lng, resources, {
          load: "all",
          debug: false,
          defaultNS: namespace,
          ns: namespace,
          backend: {
            loadPath: `/language/{{lng}}/${namespace}.json`,
            addPath: `/language/{{lng}}/${namespace}.json`,
          },
        }),
      );
  } else {
    i18n.changeLanguage(lng);
  }

  return i18n;
};

export const initBrowserI18n = async (lng: string, buildType: string) => {
  const resources = await getResourcesWithFallbacks(lng, buildType);
  const namespace = getNamespaceForBuildType(buildType);
  await configureBrowserI18n(resources, lng, namespace);
};

export const buildI18nextBrowserProvider = (buildType: string) => {
  const currentLocale = currentLanguage();
  const lang = formatLocale(currentLocale || "en");
  initBrowserI18n(lang, buildType);

  const I18nextBrowserProvider = ({ children }: { children: ReactNode }) => {
    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
  };

  return I18nextBrowserProvider;
};
